export function calcCurrList(list, pageActive, itemsPerPage) {
    console.log("🚀 ~ calcCurrrrrrrList ~ list:", list.sort((a, b) => a.id.localeCompare(b.id)))
    let totalPages = Math.ceil(list.length / itemsPerPage);
    let pageToShow = totalPages < pageActive ? totalPages : pageActive
    const indexOfLastItem = pageToShow * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    const currentItems = list.slice(indexOfFirstItem, indexOfLastItem);
    // setPageActive(pageActived)
    return { currentItems, totalPages, pageToShow }
}